import { render } from "./NotFound.vue?vue&type=template&id=7a9d2e94"
const script = {}

import exportComponent from "C:\\Users\\Anteater\\Desktop\\projects\\main-prj-01-starting-setup\\main-prj-01-starting-setup\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__